$(document).ready(function() {
  $(".bxstr-prodinfo-set > a").on("click", function() {
    if ($(this).hasClass("active")) 
    {
      $(this).removeClass("active");
      $(this)
        .siblings(".content")
        .slideUp(400);
      $(".bxstr-prodinfo-set > a i")
        .removeClass("fa-minus")
        .addClass("fa-plus");
      return false;
    } else {
      $(".bxstr-prodinfo-set > a i")
        .removeClass("fa-minus")
        .addClass("fa-plus");
      $(this)
        .find("i")
        .removeClass("fa-plus")
        .addClass("fa-minus");
      $(".bxstr-prodinfo-set > a").removeClass("active");
      $(this).addClass("active");
      $(".content").slideUp(400);
      $(this)
        .siblings(".content")
        .slideDown(400);
      
      return false;
    }
  });
});

/*
$(document).ready(function() {
         document.title = "BOXSTAR DESIGNS - AESTHETIC WORK, ENDLESS GLORY";
});
*/